var _circle, _rect, _path, _path2, _path3, _path4, _ellipse, _rect2, _path5, _rect3, _path6, _rect4, _path7, _path8, _path9, _path0, _path1, _ellipse2, _circle2, _circle3, _path10, _path11, _circle4, _ellipse3, _ellipse4, _path12, _path13, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle5, _path28, _ellipse11, _ellipse12, _path29, _path30, _circle6, _path31, _path32, _path33, _path34, _path35, _path36, _rect5, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle7, _path45, _path46, _path47, _ellipse13, _ellipse14, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _rect6, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 357,
    viewBox: "0 0 424 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 215.94,
    cy: 178.324,
    r: 178.324,
    fill: "#F1F0FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205.561,
    y: 100.581,
    width: 109.347,
    height: 169.327,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.645 203.931H295.761",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.645 215.004H295.761",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.645 226.076H295.761",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.645 237.149H295.761",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.234,
    cy: 149.949,
    rx: 28.606,
    ry: 28.606,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 295.76,
    y: 160.792,
    width: 45.215,
    height: 41.986,
    fill: "#98B9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.499 181.95L313.778 179.49V180.457L308.643 182.396L313.778 184.34V185.307L307.499 182.842V181.95ZM319.337 177.315H320.153L317.65 185.205H316.834L319.337 177.315ZM329.386 182.853L323.107 185.307V184.34L328.237 182.396L323.107 180.457V179.49L329.386 181.95V182.853Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.624,
    y: 17.3018,
    width: 244.071,
    height: 160.561,
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.624 25.8379H260.695",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3867,
    y: 40.1396,
    width: 73.36,
    height: 73.36,
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.819 46.5996H233.935",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.819 57.6729H233.935",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.819 68.7461H233.935",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.819 79.8184H233.935",
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0669 59.5176L51.0889 94.1176H91.0449L71.0669 59.5176Z",
    fill: "#918EF4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9305,
    cy: 21.6844,
    rx: 2.076,
    ry: 2.076,
    fill: "#AB8DE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.0809,
    cy: 21.6844,
    r: 2.076,
    fill: "#73E5E2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2323,
    cy: 21.6844,
    r: 2.076,
    fill: "#50B89D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.125 148.218L131.046 142.105H123.987L124.125 148.218Z",
    fill: "#AB8DE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.205 131.032C117.205 127.783 118.354 125.01 120.651 122.712C122.948 120.415 125.721 119.267 128.97 119.267H158.96C162.209 119.267 164.982 120.415 167.279 122.712C169.576 125.01 170.725 127.783 170.725 131.032C170.725 134.28 169.576 137.053 167.279 139.351C164.982 141.648 162.209 142.797 158.96 142.797H128.97C125.721 142.797 122.948 141.648 120.651 139.351C118.354 137.053 117.205 134.28 117.205 131.032Z",
    fill: "#AB8DE5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.814,
    cy: 131.032,
    r: 2.076,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.965,
    cy: 131.032,
    rx: 2.076,
    ry: 2.076,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.116,
    cy: 131.032,
    rx: 2.076,
    ry: 2.076,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.282 79.0105L336.361 72.8975H343.42L343.282 79.0105Z",
    fill: "#98B9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.203 61.8246C350.203 65.0734 349.054 67.8464 346.757 70.1437C344.459 72.4409 341.686 73.5896 338.438 73.5896H308.448C305.199 73.5896 302.426 72.4409 300.129 70.1437C297.831 67.8464 296.683 65.0734 296.683 61.8246C296.683 58.5758 297.831 55.8027 300.129 53.5055C302.426 51.2082 305.199 50.0596 308.448 50.0596L338.438 50.0596C341.686 50.0596 344.459 51.2082 346.757 53.5055C349.054 55.8027 350.203 58.5758 350.203 61.8246Z",
    fill: "#98B9F2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.595,
    cy: 61.825,
    rx: 2.076,
    ry: 2.076,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.442,
    cy: 61.825,
    rx: 2.076,
    ry: 2.076,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.291,
    cy: 61.825,
    rx: 2.076,
    ry: 2.076,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.591,
    cy: 19.6092,
    rx: 2.076,
    ry: 2.076,
    fill: "#918EF4"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.974,
    cy: 28.1444,
    rx: 2.076,
    ry: 2.076,
    fill: "#918EF4"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.221,
    cy: 112.347,
    rx: 3.23,
    ry: 3.23,
    fill: "#918EF4"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.138,
    cy: 123.419,
    rx: 3.23,
    ry: 3.23,
    fill: "#918EF4"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4683,
    cy: 127.111,
    rx: 3.23,
    ry: 3.23,
    fill: "#F98B67"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.695 274.638V274.177L302.588 272.793L300.027 269.683L297.305 266.389C297.305 266.389 294.684 264.576 294.011 264.262C291.608 263.019 288.956 262.335 286.251 262.262C284.475 262.262 277.835 262.53 277.822 263.646C277.822 265.302 287.122 271.573 293.938 274.618C296.931 274.638 303.695 274.638 303.695 274.638Z",
    fill: "#1F161E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.288 274.638C292.825 267.357 273.507 227.646 278.462 212.928C289.009 218.303 300.581 236.837 306.039 252.487C306.332 253.506 306.568 254.541 306.745 255.587L308.96 265.737L309.495 274.656L302.288 274.638Z",
    fill: "#6F9CEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.748 274.638C305.555 272.045 304.536 264.368 304.508 261.503C304.457 256.156 305.278 252.215 309.851 246.333C314.424 240.451 313.205 230.692 319.277 224.108C325.349 217.523 329.372 215.688 336.577 215.688C343.782 215.688 346.077 227.37 346.035 230.309C345.952 242.165 338.482 243.845 333.924 249.501C330.616 253.607 330.358 256.966 329.356 258.887C323.986 269.231 319.621 273.121 316.391 274.639",
    fill: "#918EF4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 273.779C310.602 253.557 331.91 223.179 336.467 218.63",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M311.658 264.589C309.3 262.019 307.158 254.734 307.478 252.842",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M305.62 272.893C302.279 266.973 286.43 238.109 280.521 216.849",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.411 274.637H326.34L318.04 305.55H295.829L287.658 274.637H316.411",
    fill: "#B37361"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M281.069 264.27C285.909 264.602 291.999 264.824 296.295 267.753",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.791 148.104C356.624 153.673 348.144 222.751 350.916 239.25C353.688 255.749 398.9 290.32 400.879 290.924C403.186 289.232 406.579 283.681 406.579 283.681C406.579 283.681 373.429 245.253 372.797 243.712C372.165 242.171 380.059 153.18 380.059 153.18L357.791 148.104Z",
    fill: "#7472C1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.779 160.676L377.954 298.634H366.563L378.107 154.715L411.779 160.676Z",
    fill: "#AB8DE5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.758 81.6875C392.427 81.6875 416.784 82.4765 421.185 91.0485C425.586 99.6205 421.439 139.249 418.703 140.781C417.227 141.607 416.825 140.803 416.396 142.48C415.967 144.157 411.782 160.673 411.782 160.673C409.124 160.747 370.382 154.91 357.8 148.087C357.874 146.187 358.483 141.259 358.483 140.88C356.813 141.562 354.792 141.705 354.238 140.88C349.329 133.446 356.646 94.6955 361.897 86.8975C364.128 83.5565 380.258 81.7105 387.758 81.6875Z",
    fill: "#6F9CEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.793 141.852C404.937 141.852 414.788 148.773 413.943 152.173C414.635 149.442 416.813 141.003 416.813 141.003C415.877 141.183 404.633 141.866 403.793 141.852Z",
    fill: "#1F161E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.785 86.2104C393.785 87.7104 381.923 87.7104 381.923 86.2104V70.9844H393.785V86.2104Z",
    fill: "#F8CDBA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.979 74.5874C387.902 74.5874 393.784 77.1874 393.784 78.6384V70.9844C392.318 70.9844 386.979 74.5874 386.979 74.5874Z",
    fill: "#1F161E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.355,
    cy: 64.1601,
    r: 11.539,
    fill: "#F8CDBA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.453 47.292C375.529 47.292 371.838 51.011 371.838 55.777C371.838 59.74 372.798 61.983 373.928 62.55C374.643 58.702 376.198 56.921 377.485 56.155C378.485 56.921 380.198 58.776 382.485 59.348C384.772 59.92 390.73 59.809 395.542 63.307C397.115 61.877 398.684 60.017 398.684 57.826C398.684 55.635 397.715 52.885 392.017 51.297C388.254 50.249 387.728 47.292 381.453 47.292Z",
    fill: "#1F161E"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.574,
    cy: 66.5364,
    rx: 2.021,
    ry: 1.052,
    fill: "#FA9E9F"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.285,
    cy: 66.5364,
    rx: 2.021,
    ry: 1.052,
    fill: "#FA9E9F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.511 64.3535C379.133 64.8935 377.204 67.1585 379.239 68.0725",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M383.312 70.7162C384.147 70.5107 384.875 69.9985 385.351 69.2812",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.022,
    cy: 65.4893,
    r: 2.667,
    fill: "#F8CDBA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M404.059 104.393C403.851 106.94 403.039 119.526 403.344 121.183C399.473 122.53 364.03 139.338 357.898 141.183",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M362.896 100.42C362.079 103.271 359.33 116.213 361.263 122.22",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M371.944 135.296C373.79 136.596 391.479 144.422 415.937 141.469",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.252 122.225C371.438 122.414 367.571 119.325 365.38 120.476C363.189 121.627 360.236 126.825 360.84 128.029C361.004 128.472 361.361 128.817 361.809 128.965C362.258 129.114 362.75 129.052 363.147 128.795C363.741 128.412 368.184 121.892 370.252 122.225Z",
    fill: "#F8CDBA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.201 284.248C406.833 284.709 412.439 288.502 412.485 290.892C412.531 293.282 407.262 301.204 406.201 301.43C405.14 301.656 404.383 300.761 404.383 299.16C404.383 297.559 406.383 294.754 406.118 293.508C405.853 292.262 403.262 289.983 401.933 289.942",
    fill: "#EBEBEB",
    fillOpacity: 0.25098
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.871 298.634C376.871 299.734 377.508 306.625 376.234 307.266C374.96 307.907 360.907 308.286 360.27 307.649C359.633 307.012 359.246 305.67 359.809 305.287C360.372 304.904 365.809 303.815 366.545 303.308C367.631 302.007 368.131 300.316 367.929 298.634",
    fill: "#EBEBEB",
    fillOpacity: 0.25098
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.001,
    y: 247.457,
    width: 89.222,
    height: 45.257,
    fill: "#B37361"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.179 226.246C145.567 228.553 152.146 281.293 153.212 282.165C154.278 283.037 165.595 284.97 166.564 283.521C166.758 281.214 167.025 244.433 167.625 241.143",
    fill: "#1F161E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8835 215.242C13.3205 212.995 22.8345 257.537 47.8735 257.537C72.9125 257.537 115.059 219.395 121.883 219.395C136.948 219.395 172.607 248.97 175.404 248.97C177.545 246.829 181.826 243.083 181.826 241.588C181.826 240.093 147.684 183.915 122.136 183.915C112.232 183.928 28.1865 220.331 17.8835 215.242Z",
    fill: "#7472C1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9747 216.002C36.9807 214.867 43.2097 211.928 48.7227 208.924C33.7227 213.824 21.4317 216.998 17.8837 215.245C15.4657 214.055 16.9977 225.977 22.6837 237.461C21.6527 235.239 20.1857 218.694 31.9747 216.002Z",
    fill: "#1F161E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0096 137.86C46.9546 137.966 67.4906 137.36 73.1196 142.723C77.2946 146.7 90.2786 180.902 92.2806 192.912C83.5606 197.346 20.6606 227.46 1.19961 214.219C0.770608 203.93 2.76861 163.029 15.4996 141.579C20.1536 138.478 39.2176 137.763 43.0096 137.86Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0107 128.073H39.0107V140.964C39.0107 144.194 51.0107 144.164 51.0107 140.964V128.073Z",
    fill: "#F8CDBA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0147 135.856C39.0147 134.426 42.9777 130.832 45.4277 130.956C45.4877 129.364 39.8277 127.076 39.8277 127.076L39.0107 129.276L39.0147 135.856Z",
    fill: "#1F161E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5738 128.074C63.8433 126.825 63.9794 125.551 63.9798 124.274C63.9798 114.76 56.5468 107.046 47.3698 107.046C38.1928 107.046 30.7598 114.76 30.7598 124.274C30.7598 125.547 30.8955 126.82 31.1648 128.069L63.5738 128.074Z",
    fill: "#1F161E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1955 116.461C57.1605 116.152 55.1305 114.551 53.7145 113.504C45.6405 119.419 40.4685 119.494 39.9095 119.494C39.3505 119.494 37.0765 122.761 36.0295 123.13L35.9375 123.075C36.7719 127.777 40.1931 131.604 44.7731 132.957C49.3531 134.311 54.3047 132.958 57.5609 129.465C60.8171 125.971 61.8183 120.937 60.1465 116.463C59.8311 116.502 59.512 116.502 59.1965 116.463L59.1955 116.461Z",
    fill: "#F8CDBA"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3736,
    cy: 104.295,
    r: 4.9,
    fill: "#1F161E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5551 119.233C39.4527 119.282 38.584 120.19 38.584 121.293C38.584 122.397 39.4527 123.305 40.5551 123.353",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2617 119.496C56.8617 120.303 58.4207 121.72 56.2617 123.219",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7143 124.3C49.6592 125.357 50.2849 126.332 51.2693 126.722",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6959,
    cy: 123.456,
    rx: 1.901,
    ry: 0.987,
    fill: "#FA9E9F"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.8278,
    cy: 123.456,
    rx: 1.901,
    ry: 0.987,
    fill: "#FA9E9F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6865 173.511L85.5085 170.211C86.7405 172.306 92.7385 192.888 92.7385 192.888L72.9465 201.231C73.2035 197.332 73.9825 179.477 72.6865 173.511Z",
    fill: "#F8CDBA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7293 170.285C27.2912 173.738 26.5973 177.154 25.6533 180.505",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6863 173.511C72.3773 171.07 70.5683 157.317 67.4863 150.077",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6865 173.511L85.5085 170.211C86.7405 172.306 92.7385 192.888 92.7385 192.888L72.9465 201.231C73.2035 197.332 73.9825 179.477 72.6865 173.511Z",
    fill: "#F8CDBA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.786 247.88C176.072 248.341 179.892 253.029 181.244 253.08C182.596 253.131 190.804 247.571 190.444 246.38C190.084 245.189 184.935 245.965 184.049 245.545C182.743 244.722 181.65 243.601 180.861 242.274",
    fill: "#1F161E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.6 282.655C155.5 283.167 154.982 289.207 155.918 290.185C156.854 291.163 166.618 292.861 167.19 291.749C167.762 290.637 163.499 287.624 163.171 286.711C162.809 285.214 162.809 283.651 163.171 282.153",
    fill: "#1F161E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.288 194.181H96.8398L107.184 166.77H150.632L140.288 194.181Z",
    fill: "#969696"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6357,
    y: 193.147,
    width: 43.448,
    height: 1.033,
    fill: "#969696"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6536 180.509C24.8186 183.628 20.7626 197.009 22.4146 199.315C24.0666 201.621 65.4336 196.394 76.5026 192.948C79.3216 192.025 81.4116 189.608 82.6616 189.294C85.9866 188.73 89.2019 190.764 90.1176 194.009C85.7016 196.15 21.8796 228.733 1.20161 214.232C-2.70639 211.432 4.14961 177.289 4.46361 175.568C7.95461 175.988 25.6536 180.509 25.6536 180.509Z",
    fill: "#F8CDBA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2773 193.78C74.5233 193.48 75.6124 193.194 76.5073 192.917C79.3263 191.994 81.4163 189.577 82.6663 189.263C85.9913 188.699 89.2066 190.732 90.1223 193.978",
    stroke: "#1F161E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.346b5c84e317a2c4b955649998c0a992.svg";
export { ForwardRef as ReactComponent };